module.exports = __webpack_public_path__ + "img/qb.e85f20de.png";